import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./banner.css";
import htmlParser from "html-react-parser";

import Header from "../HeaderHome/index";

export default function Banner({ bannerData }) {
  const [navbar, setNavbar] = useState(false);
  const imgCDNURL = process.env.REACT_APP_CDN_URL;
  return (
    <>
      <div className="bannerbg">
        <Container className="pt-3">
          <Header />
          <Row>
            <Col sm={12} md={12} lg={12} xl={12} className="dpaHeadingcol">
              <h4 className="dpaheadinghome">
                {htmlParser(bannerData.bannerHeading)}
              </h4>
              <div className="maindivofdiv">
                <div className="topidiv">
                  <img
                    src={imgCDNURL + "homecap.webp"}
                    className="img-fluid homecal"
                    alt="homecap"
                  ></img>
                </div>
                <div className="ignoremacediv">
                  <h4 className="dpaheadingorancehome">
                    {htmlParser(bannerData.bannermobHeading)}
                  </h4>
                </div>
                <div className="arrowdiv">
                  <img
                    src={imgCDNURL + "arrowright.webp"}
                    className="img-fluid arrowright"
                    alt="arrowright"
                  ></img>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
